

export default {
    name: 'atlas',
    props: ['source'],
    data() {
        return {
            type: 'atlas',
            activityStyle:{
                "backgroundColor":"#fff",
                "borderRadius":"6px",
                "boxShadow":"0 4px 12px rgba(0,0,0,.06)",

            }
        }
    },
    computed: {
        /** 列表带 edit_status 时优先用它；没有该字段再按 status */
        reviewLabel() {
            const source = this.source || {}
            const editStatus = source.edit_status
            const hasEditStatus = editStatus !== undefined && editStatus !== null
            if (hasEditStatus) {
                if (editStatus === 0) return this.$t('page.EDIT_CONTENT_PENDING')
                if (editStatus === -3) return this.$t('page.EDIT_CONTENT_REJECTED')
                return ''
            }
            if (source.status == 0) return '! The work is under review'
            if (source.status == -1) return 'deleted'
            if (source.status == -2) return 'Audit not passed'
            return ''
        },
    },
    mounted() {
        if (this.$route.name.includes('events')) {
            this.type = 'events'
        }
        console.log(this.$route.path.includes('events'),'$route.path$route.path$route.path');
    },
    watch: {
        source(val) {
            this.source = val
        }
    },

    methods: {
        async likeOperation() {
            //点赞 取消点赞
            // type 1是作品点赞、取消点赞 20是教程点赞、取消点赞 7作品评论点赞、取消点赞 8教程咨询评论点赞、取消点赞 21帖子点赞 取消点赞 22 帖子评论点赞 取消点赞
            let res = await this.$global.likeaction({ "relation_id": this.source.id, "type": "1" })
            if (res.code == 200) {
                this.source.is_like = res.data.hasClick
                res.data.hasClick == 0 ? this.source.like_num = this.source.like_num - 1 : this.source.like_num = this.source.like_num + 1
            }

        },
        getThumbWithResize(url) {
            if (!url) return '';
            if (url.includes('x-oss-process=')) return url;
            const separator = url.includes('?') ? '&' : '?';
            return `${url}${separator}x-oss-process=image/resize,m_lfit,w_256,h_192`;
        },
        handleAtlasImgError(event, source) {
            if (event.target.dataset.thumbFallback === '1') return;
            const fallbackUrl = this.getThumbWithResize(source.thumb);
            if (fallbackUrl && event.target.src !== fallbackUrl) {
                event.target.dataset.thumbFallback = '1';
                event.target.src = fallbackUrl;
            }
        },
        pathFiltering(source) {
            const { thumb_video, thumb_cover_original, video_cover_original, thumb } = source;
            if (source.hasOwnProperty('cont_type')) {
                return thumb_video !== "" ? (video_cover_original !== "" ? video_cover_original : thumb_video) : (thumb_cover_original !== "" ? thumb_cover_original : this.getThumbWithResize(thumb));
            } else {
                return video_cover_original !== "" ? video_cover_original : (thumb_cover_original !== "" ? thumb_cover_original : this.getThumbWithResize(thumb));
            }
        }
    }
}
